import { trackClientEvent } from '@faire/web-api--source/trackClientEvent';
import { ITraceEventMarker } from '@faire/web--source/common/pete/TraceEventTracker';

export const eventKey =
  'retailer_marketing-builder_marketing_landing_page-view';

/**
 * track when a landing page is viewed
 */
export function trackRetailerMarketingBuilderMarketingLandingPageView(
  customParameterToken: string,
  retailerToken: string
): ITraceEventMarker {
  return trackClientEvent({
    eventKey,
    realTimeTracking: false,
    parameters: { customParameterToken, retailerToken },
  });
}
